export default __webpack_public_path__ + "static/795-b6bef42c05f5fb3006978c50a9dc93cc.gif";